<div class="container" *ngIf="activePayment$ | async as payment">
   <form [formGroup]="paymentForm" >
      <div class="buttons mb-0">

         <button class="button is-primary is-small" (click)="addAddition('Poşet', 0.5, false)" >
            <span class="icon">
               <i class="fas fa-shopping-bag fa-lg"></i>
             </span>
             <!-- <span>Kargo</span> -->

         </button>
         <button class="button is-info is-small" (click)="addAddition('Kargo bedeli', 15, false)" >
            <span class="icon">
               <i class="fas fa-truck fa-lg"></i>
             </span>
             <!-- <span>Kargo</span> -->

         </button>
         <button class="button is-link is-small" (click)="addAddition('Kapıda ödeme', 10, false)" >
            <span class="icon">
               <i class="fas fa-door-open fa-lg"></i>
             </span>
             <!-- <span>Kargo Hizmet</span> -->
            </button>
         <button class="button is-warning is-small" (click)="addAddition('Hediye puanı', 0, true)">
            <span class="icon has-text-white">
               <i class="fas fa-gift fa-lg"></i>
             </span>
             <!-- <span>Gift</span> -->
            </button>
         <button class="button is-danger is-small" (click)="addAddition('Kasiyer indirimi', 0, true)">
            <span class="icon">
               <i class="fas fa-user-tag fa-lg"></i>
             </span>
             <!-- <span>Discount</span> -->
            </button>
      </div>
      <div class="field has-addons">
         <div class="control">
            <p class="button is-primary is-small" disabled>Sepet toplamı</p>
         </div>

         <p class="control">
            <input class="input is-small" type="number" formControlName="cartTotal" readonly />
         </p>
      </div>

      <div formArrayName="additions" *ngIf="additions">
         <div 
            class="field has-addons "
            *ngFor="let addition of additions.controls; index as j"
            [formGroupName]="j">
            <div class="control">
               <p class="button is-primary is-small" disabled>{{addition.value.name}} </p>
            </div>
            <div class="control">
               <input class="input is-small" type="number" formControlName="amount" >
            </div>

         </div>
      </div>
      

      <hr>

      <div class="field has-addons">
         <div class="control">
            <p class="button is-primary" disabled>Genel toplam</p>
         </div>

         <p class="control">
            <input class="input" type="number" formControlName="grandTotal" readonly />
         </p>
      </div>

      

      <!-- <div formArrayName="transactions" *ngIf="paymentForm.get('transactions').value"> -->
      <div formArrayName="transactions" *ngIf="transactions">
         <ng-container *ngIf="paymentTypes$ | async as pymTyps">
            <div
               class="field has-addons mb-0"
               *ngFor="let transaction of transactions.controls; index as i; last as isLast"
               [formGroupName]="i"
            >
               <p class="control">
                  <span class="select">
                     <select formControlName="type" placeholder="seçin">
                        <!-- <option value="">Seçin</option> -->
                        <option *ngFor="let type of paymentTypesNames" [value]="type">{{ type }}</option>
                     </select>
                  </span>
               </p>

               <p class="control">
                  <!-- <input class="input" type="number" [placeholder]="cart.payment.remainingValue / paymentTypes[lastPaymentType].tlValue " formControlName="amount" /> -->
                  <input
                     class="input"
                     type="number"
                     [placeholder]="payment.remainingValue / pymTyps[paymentForm.value.transactions[i].type].tlValue"
                     formControlName="amount"
                  />
               </p>

               <p class="control" *ngIf="isLast">
                  <a class="button is-primary" (click)="addTransaction()">
                     <span class="icon is-large">
                        <i class="fas fa-plus fa-lg"></i>
                     </span>
                  </a>
               </p>

               <p class="control" *ngIf="!isLast">
                  <a class="button is-primary" (click)="removeTransaction(i)">
                     <span class="icon is-medium"> <i class="fas fa-minus fa-lg"> </i> </span>
                  </a>
               </p>
            </div>
         </ng-container>
      </div>

      <div class="field has-addons">
         <div class="control">
            <button class="button is-warning is-fullwidth" disabled *ngIf="remainingValue.value < 0">
               Para üzeri TL
            </button>
            <button class="button is-danger is-fullwidth" disabled *ngIf="remainingValue.value > 0">Kalan TL</button>
         </div>
         <div class="control">
            <input class="input" type="number" formControlName="remainingValue" readonly />
         </div>
      </div>
      <div class="buttons">
         <button class="button is-primary is-fullwidth" type="submit" [disabled]="paymentForm.invalid" >
            <span class="icon is-small">
               <i class="far fa-save fa-lg"></i>
            </span>
            <span>Kaydet</span>
         </button>
         <button class="button is-warning is-outlined" (click)="resetForm()">
            <span class="icon is-small">
               <i class="far fa-trash-alt fa-lg"></i>
            </span>
            <span>Reset</span>
         </button>
         <button class="button is-info is-outlined" >
            <span class="icon is-small">
               <i class="fas fa-pen fa-lg"></i>
            </span>
            <span>LOG</span>
         </button>
      </div>
   </form>

   <div *ngIf="true">
      <p class="subtitle">Alınan toplam: {{ payment.totalTransactionValue }} TL</p>
      <p class="subtitle">İskonto: {{ payment.activeDiscount }}</p>
      <!-- <p>deneme: {{convertToLastTransactionType() | async}} </p> -->
      <!-- <p>Transaction.length {{transactions.length}} </p> -->
      <!-- <p>CartCode: {{cart.cartCode}} </p> -->
      <!-- <p *ngIf="(transactions.at(transactions.length - 1).get('type').value) as pymtype"> {{ cart.payment.remainingValue / convertToLasttransactionType()}} {{pymtype}}</p> -->
      <!-- <p *ngIf="convertToLasttransactionType()"> {{convertToLasttransactionType()}} </p> -->
   </div>
</div>

<p>paymentForm: {{ paymentForm.value | json }}</p>
<p>paymentForm: {{ paymentForm.status | json }}</p>
<hr />
<p>activePaymet$ from service: {{ activePayment$ | async | json }}</p>
<hr />

<!-- <p>activeCart in payment component: {{ activeCart$ | async | json }}</p> -->
